import { createMuiTheme } from "@material-ui/core";
import { overrides } from "./overrides";
import { palette } from "./palette";
import { typography } from "./typography";

export const theme = createMuiTheme({ overrides, palette, typography });
